import { inject, Service } from '@angular/core';

import { BaasAppState } from '@lvflanders/bar';
import { _BaasBurgerprofielContactLink, _BarBurgerprofielEngine } from '@lvflanders/bar-ng-ui';

import { BaasContainerKlantnummerWidget } from './baas-container-klantnummer-widget';
import { BURGERPROFIEL_CONTACT_ACTION_FORM } from './burgerprofiel-startscherm-contact-form-hook';

/**
 * Service for managing burgerprofiel integration in BaasContainer.
 * Handles configuration of burgerprofiel contact links and service points.
 */
@Service({ autoProvided: false })
export class BaasContainerBurgerprofielService {
    readonly #burgerprofielEngine = inject(_BarBurgerprofielEngine);
    readonly #state = inject(BaasAppState);
    /**
     * Configures the burgerprofiel contact service points with optional help link
     * @param helpLink Optional help link URL to display in burgerprofiel
     */
    defineContacts(helpLink?: string): void {
        if (!this.#burgerprofielEngine.visible) return;

        const hasHelpLink = !!helpLink;
        const contextual: _BaasBurgerprofielContactLink[] = [];

        // Add help link only if defined
        if (hasHelpLink) {
            contextual.push({
                behavior: 'regular',
                href: helpLink,
                label: 'Help pagina',
                icon: 'e-desk'
            });
        }

        // Always add contact form
        contextual.push({
            behavior: 'action',
            // this maps to a burgerprofiel contact hook
            action: BURGERPROFIEL_CONTACT_ACTION_FORM,
            label: 'Stel je vraag',
            icon: 'question'
        });

        const contactUrl = this.#state.config?.baasStatic?.burgerprofiel?.contactUrl;
        if (contactUrl) {
            contextual.push({
                behavior: 'regular',
                href: contactUrl,
                label: 'Contacteer ons',
                icon: 'headphones'
            });
        }

        this.#burgerprofielEngine._setContactServicePoints({
            displayMode: 'grouped',
            groupLabel: hasHelpLink ? 'Hulp en contact' : 'Contact',
            contextual,
            // this is going to be injected in the contact header
            headerComponent: BaasContainerKlantnummerWidget
        });
    }

    /**
     * Returns whether the burgerprofiel widgets are visible
     */
    get visible(): boolean {
        return this.#burgerprofielEngine.visible;
    }
}
